import {combineReducers} from 'redux';
import {all} from "@redux-saga/core/effects";

import currencyDataReducer from './currency/reducers/fetch-currency-data-reducer';
import authReducer from './auth/reducers/auth-reducer';
import searchCustomersReducer from './customer/reducers/search-customers-data-reducer'
import getCustomerReducer from './customer/reducers/get-customer-reducer';
import createCustomerReducer from "./customer/reducers/create-customer-reducer";
import searchProductsReducer from "./product/reducers/search-product-data-reducer";
import createProductReducer from "./product/reducers/create-product-reducer";
import orderReducer from "./order/reducers/order-reducer";
import searchNewsReducer from "./news/reducer/search-news-reducer";
import createNewsReducer from "./news/reducer/create-news-reducer";
import updateNewsReducer from "./news/reducer/update-news-reducer";
import updateCustomerReducer from "./customer/reducers/update-customer-reducer";
import watchDeleteCustomer from "./customer/sagas/delete-customer-saga";
import deleteCustomerReducer from "./customer/reducers/delete-customer-reducer";
import deleteProductReducer from "./product/reducers/delete-product-reducer";
import deleteNewsReducer from "./news/reducer/delete-news-reducer";

import orderSaga from "./order/sagas/order-saga";
import {watchUpdateNews} from "./news/saga/update-news-saga";
import {watchUpdateCustomer} from "./customer/sagas/update-customer-saga";
import {watchGetCustomer} from "./customer/sagas/get-customer-saga";
import {watchCreateNews} from "./news/saga/create-news-saga";
import {watchSearchForNews} from "./news/saga/search-news-saga";
import {authSaga} from "./auth/sagas/auth-saga";
import {watchFetchCurrencyData} from "./currency/sagas/fetch-currency-data-saga";
import {watchSearchForCustomers} from "./customer/sagas/search-customers-saga";
import {watchCustomerCreateFormSubmit} from "./customer/sagas/create-customer-saga";
import {watchSearchForProducts} from "./product/sagas/search-products-saga";
import {watchProductCreateFormSubmit} from "./product/sagas/create-product-saga";

import watchDeleteProduct from "./product/sagas/delete-customer-saga";
import watchDeleteNewsSaga from "./news/saga/delete-news-saga";
import {watchUpdateProductSaga} from "./product/sagas/update-product-saga";
import updateProductReducer from "./product/reducers/update-product-reducer";
import calculationReducer from './calculations/reducer'
import calculationSaga from "./calculations/sagas";
import userReducer from './user/reducers/user-reducer';
import userSaga from './user/sagas/user-saga';
import boardReducer from './boards/reducers/board-reducer';
import taskReducer from './boards/reducers/task-reducer';
import boardSaga from './boards/sagas/board-saga';
import taskSaga from './boards/sagas/task-saga';

export const rootReducer = combineReducers({
    searchCustomersData: searchCustomersReducer,
    getCustomer: getCustomerReducer,
    createCustomer: createCustomerReducer,
    updateCustomer: updateCustomerReducer,
    deleteCustomer: deleteCustomerReducer,
    createNewsData: createNewsReducer,
    searchNewsData: searchNewsReducer,
    updateNewsData: updateNewsReducer,
    deleteNews: deleteNewsReducer,
    searchProductsData: searchProductsReducer,
    createProduct: createProductReducer,
    updateProduct: updateProductReducer,
    deleteProduct: deleteProductReducer,
    auth: authReducer,
    orderData: orderReducer,
    currencyData: currencyDataReducer,
    calculationsData: calculationReducer,
    user: userReducer,
    boards: boardReducer,
    tasks: taskReducer

});


export function* rootSaga() {
    yield all([
        authSaga(),
        watchFetchCurrencyData(),
        watchSearchForCustomers(),
        watchGetCustomer(),
        watchCustomerCreateFormSubmit(),
        watchUpdateCustomer(),
        watchDeleteCustomer(),
        watchSearchForProducts(),
        watchProductCreateFormSubmit(),
        watchDeleteProduct(),
        watchUpdateProductSaga(),
        orderSaga(),
        watchSearchForNews(),
        watchCreateNews(),
        watchUpdateNews(),
        watchDeleteNewsSaga(),
        calculationSaga(),
        userSaga(),
        boardSaga(),
        taskSaga()
    ]);
}


